import styled$1 from 'styled-components';
import { space, colorSet, mq } from '@ccg/core';
import '@4rk/modular-system';
import '../../styles/typography.js';
import { getTransitionProperty } from '../../styles/transitions.js';
import { getGrid } from '../Grid/Grid.js';
import { getImageAlignment, getCaptionAlignment } from './helper/index.js';

/* eslint-disable indent */
const StyledMediaContent = styled$1.div`
  ${getGrid()}
  position: relative;
  margin-top: ${space(10)};
  margin-bottom: ${space(10)};
  padding: 0;

  .mediaContent__media-wrapper {
    position: relative;
    ${getImageAlignment}

    img,
    video {
      width: 100%;
      display: block;
    }
  }

  .mediaContent__credits {
    position: absolute;
    transform: rotate(-90deg);
    transform-origin: top left;
    right: -20px;
    color: ${colorSet('accent')};
    left: -20px;
  }

  .mediaContent__meta {
    ${getCaptionAlignment}
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: ${space(4)};
    margin-bottom: 0;

    ${mq('m')} {
      ${getTransitionProperty('padding')};
      margin-top: ${space(4)};
    }
  }
`;

export default StyledMediaContent;
